import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { mdiClose } from '@mdi/js';
import ReactModal from 'react-modal';
import { useTheme } from 'styled-components';
import sendEvent from '@upgrade/ui-utils/utils/mobile-app/send-event';
import IconButton from '../IconButton';
import useWindowMinWidth from '../hooks/useWindowMinWidth';
import { CloseIcon, getContentStyle, getOverlayStyle, GlobalModalStyle } from './styles';
import ErrorBoundary from '../ErrorBoundary';
export default function Modal({
  className,
  visible,
  children,
  onClose = null,
  title = 'Modal',
  shouldCloseOnOverlayClick = true,
  useBottomSheetOnMobile = false,
  closeIconSmallRegion = false,
  closeIconDisplayed = true,
  wrapWithErrorBoundary = true,
  errorBoundaryProps = {},
  reactModalProps = {},
  size = 'auto',
  contentStyle = null,
  ...props
}) {
  const theme = useTheme();
  const [isWiderThanXs] = useWindowMinWidth('xs');
  useEffect(() => {
    // Send Mobile Event
    sendEvent({
      type: 'WEB_MODAL_VISIBLITY_CHANGED',
      data: visible
    });
  }, [visible]);
  const handleOnClose = e => {
    e.preventDefault();
    onClose?.();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactModal, _extends({
    style: {
      content: contentStyle || getContentStyle({
        ...props,
        size,
        theme,
        isWiderThanXs,
        useBottomSheetOnMobile
      }),
      overlay: getOverlayStyle({
        ...props,
        theme,
        isWiderThanXs,
        useBottomSheetOnMobile
      })
    },
    contentLabel: title,
    isOpen: visible,
    onRequestClose: handleOnClose
  }, reactModalProps, {
    className,
    shouldCloseOnOverlayClick
  }), closeIconDisplayed && onClose && /*#__PURE__*/React.createElement(CloseIcon, {
    $closeIconSmallRegion: closeIconSmallRegion
  }, /*#__PURE__*/React.createElement(IconButton, {
    label: "Close Modal",
    color: "content",
    colorHover: "content",
    size: "small",
    icon: mdiClose,
    "data-auto": "modal-close-icon",
    onClick: handleOnClose
  })), wrapWithErrorBoundary ? /*#__PURE__*/React.createElement(ErrorBoundary, _extends({
    marginProps: {
      top: 'lg'
    }
  }, errorBoundaryProps), children) : children), /*#__PURE__*/React.createElement(GlobalModalStyle, {
    useBottomSheetOnMobile: useBottomSheetOnMobile
  }));
}
Modal.setAppElement = ReactModal.setAppElement;
Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string,
  shouldCloseOnOverlayClick: PropTypes.bool,
  useBottomSheetOnMobile: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  size: PropTypes.oneOf(['small', 'medium', 'large', 'full', 'auto']),
  contentStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  closeIconSmallRegion: PropTypes.bool,
  closeIconDisplayed: PropTypes.bool,
  wrapWithErrorBoundary: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  errorBoundaryProps: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  reactModalProps: PropTypes.object
};
//# sourceMappingURL=index.js.map